import { render } from "./ProductPreviewGallery.vue?vue&type=template&id=0cf37249"
import script from "./ProductPreviewGallery.vue?vue&type=script&lang=js"
export * from "./ProductPreviewGallery.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__